import { GET, POST } from "../../../../module/services/fetch";
import { map } from "rxjs/operators";
import { IUigpConfigurationItem } from "./constants";

export const fetchUigpConfiguration = () =>
  GET(`admin/configuration`).pipe(map((response: any) => response));

export const updateUigpConfiguration = (newConfig: IUigpConfigurationItem) =>
  POST(`admin/configuration/${newConfig.configuration}`, newConfig).pipe(
    map((response: any) => response)
  );
